import get from "lodash/get";
import type { Action } from "../../actions/types";

export type StoreState = {
  code?: string;
  status?: string;
  transactionId?: string;
};

export const initialState = {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "ACCOUNT_CREDIT_REDEEM_SUCCESS": {
      const transactionId = get(
        action,
        "response.data.transaction.transaction.id"
      );

      return { ...state, transactionId };
    }

    case "POLL_FOR_REWARD_SUCCESS": {
      const data = JSON.parse(get(action.response, "data", "{}"));
      const code = get(data, "definition.code");

      return { ...state, code, status: "success" };
    }

    case "EXCHANGE_REDEEM_SUCCESS": {
      const code = get(
        action,
        "response.data.transaction.transaction.definition.code"
      );

      return { ...state, code, status: "success" };
    }

    case "SET_EXCHANGE_ID": {
      return { ...state, code: undefined, status: "pending" };
    }

    case "POLL_FOR_REWARD_REQUEST": {
      return { ...state, status: "pending" };
    }

    case "POLL_FOR_REWARD_FAILURE": {
      return { ...state, status: "error" };
    }

    case "EXCHANGE_REDEEM_FAILURE": {
      return { ...state, status: "error" };
    }

    default:
      return state;
  }
}
